<script>
    import { onMount } from 'svelte';
    import ModalTitle from "./Modal/ModalTitle.svelte";
    import ModalButtons from "./Modal/ModalButtons.svelte";
    import { fetchCurrentAuthToken, formRequestAction } from "../scripts/awsUtils.js";
    import dbData from "../Stores/utilityDBStore.js";

    let aDate = new Date(0);
    
    $: dateText = updateDateText(aDate);

    onMount(() => {
        updateTick(false);
    });

    function updateDateText(date) {
        if ($dbData.wpn_id == "WPNDemo002") {
            return "Managed by 64seconds";
        } else if (date.getTime() > 0) {
            const date_options = {
                weekday: 'long',    // e.g., "Monday"
                year: 'numeric',    // e.g., "2023"
                month: 'long',      // e.g., "August"
                day: 'numeric',     // e.g., "29"
                hour: 'numeric',    // e.g., "3 PM" or "15"
                minute: '2-digit',  // e.g., "05"
                second: undefined,  // e.g., "09"
                timeZoneName: undefined, // e.g., "PST"
                hour12: true        // 12-hour clock (true) or 24-hour clock (false)
            };
            return date.toLocaleString('en-US', date_options);
        } else {
            return "Unknown";
        }
    }

    function updateTick(willSetTick) {
        var tick = document.getElementById("green-tick");
        tick.style.display = (willSetTick == true) ? "inline" : "none";
    }

    async function sendSurveyAnalysisRequest() {
        sendAnalysisRequest("survey_analysis");
    }

    async function sendCorrelationAnalysisRequest(analysisType) {
        sendAnalysisRequest("correlation_analysis");
    }

    async function sendAnalysisRequest(analysisType) {
        if ($dbData.wpn_id == "WPNDemo002") {
            return;
        }
        let currentDate = new Date();
        let differenceInMilliseconds = currentDate.getTime() - aDate.getTime();
        let elapsedSeconds = differenceInMilliseconds / 1000;
        if (elapsedSeconds < 1800) {
            return;
        }
        try {
            let promise = new Promise(fetchCurrentAuthToken);
            promise.then((authToken) => {
                if (analysisType == "survey_analysis") {
                    handleSurveyAnalysis(authToken);
                } else if (analysisType == "correlation_analysis") {
                    handleCorrelationAnalysis(authToken);
                }
            });
        } catch (error) {
            alert(
                "An error has occurred, please check internet connection and try again."
            );
            console.log(error);
            updateTick(false);
        }
        return;
    }

    async function handleSurveyAnalysis(authToken) {
        try {
            const ra = formRequestAction("alfx_analysis", { wpn_id: $dbData.wpn_id }, authToken);
            const resAnalysisRequest = await fetch(ra.url, ra.initData);
            let didSucceed = (resAnalysisRequest.ok)
            if (didSucceed) {
                aDate = new Date();
            } else {
                alert("An error has occurred, please check internet connection and try again.");
            }
            updateTick(didSucceed);
        } catch(error) {
            console.error('Error sending Survey Analysis request: ', error);
        }
    }

    async function handleCorrelationAnalysis(authToken) {
        try {
            const ra = formRequestAction("correlation_analysis", { wpn_id: $dbData.wpn_id }, authToken);
            const resAnalysisRequest = await fetch(ra.url, ra.initData);
            let didSucceed = (resAnalysisRequest.ok)
            if (didSucceed) {
                aDate = new Date();
            } else {
                alert("An error has occurred, please check internet connection and try again.");
            }
            updateTick(didSucceed);
        } catch(error) {
            console.error('Error sending Correlation Analysis request: ', error);
        }
    }

</script>

<div>
    <ModalTitle title="Analysis" on:close />
</div>
<div class="analysis-container">
    <div class="start-analysis-container">
        <div class="alfx-analysis-banner">
            <img
                src="/images/iconALFXLogo.png"
                alt="Item logo"
            />
            <h2>ALFX Analysis</h2>
        </div>
        <div class="analysis-request">
            <h4>Start Analysis</h4>
            <p id="by-line">Analysis takes a few minutes, we'll email you when it's ready.</p>
            <div class="centered-text">
                <span class="title">Last Analysis Started:</span>
                <span id="analysis-date-text">{dateText}</span>
                <span id="green-tick" class="green-tick">&#10003;</span>
            </div>
        </div>
    </div>
    <footer>
        <slot name="footer">
            <ModalButtons
                actions={["close", "survey_analysis", "corr_analysis", "reload_analysis"]}
                on:close
                on:reload_analysis
                on:survey_analysis={sendSurveyAnalysisRequest}
                on:corr_analysis={sendCorrelationAnalysisRequest}
                />
        </slot>
    </footer>    
</div>

<style>
    .analysis-container {
        display: flex;
        flex-direction: column;
        min-height: 100vh; /* Make sure it takes the full viewport height */
    }
    .start-analysis-container {
        flex: 0.25;
        height: 32vh;
    }
    .alfx-analysis-banner {
        display: flex;
        align-items: center;
        padding: 1rem;
        justify-content: center;
    }
    h2 {
        /* margin: 0 auto; */
        padding-top: 2px;
        font-weight: 300;
        font-size: xx-large;
        color: rgb(67, 148, 11);
    }
    h4 {
        color: #0A6EBD;
        font-weight: 400;
        font-size: larger;
        margin: auto;
    }
    .analysis-request {
        width: 80%;
        margin: 16px auto;
        text-align: center;
        background-color: #ffffff;
        border-radius: 16px;
        padding: 16px 0 24px 0;
    }
    #by-line {
        margin-bottom: 32px;
    }
    .centered-text {
        display: flex; /* Enables flexbox layout */
        justify-content: center; /* Centers the content horizontally */
        align-items: center; /* Centers the content vertically */
        gap: 5px; /* Optional: Adds space between title and description */
    }
    .title {
        font-weight: bold; /* Makes the title bold */
    }
    .green-tick {
        color: green;
        font-size: 24px;
    }
</style>
